import type { ReactNode } from 'react';

type Props = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export function AuthShell({ title, subtitle, children, footer }: Props): JSX.Element {
  return (
    <main className="min-h-screen bg-bg-soft px-6 py-12 flex items-center justify-center">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <p className="text-xs uppercase tracking-wide text-ink-2 mb-2">LYN Rx</p>
          <h1 className="text-2xl font-semibold text-ink">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-ink-2">{subtitle}</p> : null}
        </div>
        <div className="rounded-lg border border-border bg-bg p-6 shadow-sm">{children}</div>
        {footer ? <div className="mt-6 text-center text-sm text-ink-2">{footer}</div> : null}
      </div>
    </main>
  );
}

type AlertProps = { children: ReactNode };

export function ErrorAlert({ children }: AlertProps): JSX.Element {
  return (
    <div
      role="alert"
      className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
    >
      {children}
    </div>
  );
}

export function InfoAlert({ children }: AlertProps): JSX.Element {
  return (
    <div
      role="status"
      className="rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800"
    >
      {children}
    </div>
  );
}
